export const WebRoutes = Object.freeze({
  // NOT LOGGED
  WrongPage: "*",
  EntryPage: "/",
  UserLoginPage: "/UserLoginPage",
  StudentLoginPage: "/StudentLoginPage",
  Logout: "/Logout",
  UserNotEnabled: "/UserNotEnabled",

  // LOGGED COMMON
  InboxPage: "/InboxPage",
  NoRolePage: "/NoRolePage",
  ChangePasswordPage: "/ChangePassword",

  // LOGGED STUDENT
  StudentHomePage: "/StudentHomePage",
  StudentProfilePage: "/StudentProfilePage",
  SummaryBooks: "/SummaryBooks",

  // LOGGED USER
  UserHomePage: "/UserHomePage",
  StudentOverviewPage: "/StudentOverviewPage",
  StatsOverviewPage: "/StatsOverviewPage",
  BookOverviewPage: "/BookOverviewPage",
  BarcodeOverviewPage: "/BarcodeOverviewPage",
  SchoolOverviewPage: "/SchoolOverviewPage",
  ImportOverviewPage: "/ImportOverviewPage",
  KeyValueAdministrationPage: "/KeyValueAdministrationPage",
  LanguagesAdministrationPage: "/LanguagesAdministrationPage",
  LogsAdministrationPage: "/LogsAdministrationPage",
  UsersAdministrationPage: "/UsersAdministrationPage",
  UserProfilePage: "/ProfilePage",
  PreregistrationDashboard: "/PreregistrationDashboard",
  PreregistrationSchools: "/PreregistrationSchools",
  PreregistrationBooks: "/PreregistrationBooks",

  // LOGGED SCHOOL
  SchoolHomePage: "/SchoolHomePage",
  SchoolProfilePage: "/SchoolProfilePage",
  SchoolReturnPage: "/SchoolReturnPage",
  SchoolManagementPage: "/SchoolManagementPage",
  SchoolDeadlineManagementPage: "/SchoolDeadlineManagementPage",

  // IDDINK EMPLOYEE
  IddinkEmployeeHome: "/IddinkEmployeeHome",

  // IDDINK SCHOOL MANAGER
  IddinkSchoolManagerHome: "/IddinkSchoolManagerHome",

  // SCHOOL BOOK MANAGER
  SchoolReturns: "/SchoolReturns",
  SchoolBookPurchase: "/SchoolBookPurchase/:schoolId/:id",
  SchoolBookPurchaseQuantity: "/SchoolBookPurchaseQuantity/:schoolId/:id",
  SchoolBookSummaryPurchase: "/SchoolBookPurchase/:schoolId/:id/Summary",
  SchoolPackageReturns: "/SchoolPackageReturns/:id",
  SchoolSummary: "/SchoolPackageReturns/:id/Summary",
  PackageReturns: "/SchoolPackageReturns/:schoolId/PackageReturns/:packageId/:year",

  LogisticsPackage: "/LogisticsPackage/:id",

});
